import { ca } from '@cian/analytics';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../types/analytics';

interface ITrackNaturalDepositModalOpenParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
}

export const trackNaturalDepositLinkClick = (params: ITrackNaturalDepositModalOpenParams) => {
  const { analyticsOfferStatus, analyticsProduct } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'Click',
    label: 'balance',
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
      },
    },
  });
};

export const trackLegalDepositLinkClick = (category: TAnalyticsOfferStatus) => {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'click_pay_lk',
    label: 'balance',
  });
};
